import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { fetchCartItems } from '../../redux/actions/cartAction';
import "./FixedCartIcon.css";

const FixedCartIcon = () => {
    const { t, i18n } = useTranslation("global");
    const dispatch = useDispatch();
    
    // جلب بيانات السلة من Redux store
    const { totalQuantity } = useSelector((state) => state.cart);

    // جلب بيانات السلة عند تحميل الكومبوننت
    useEffect(() => {
        dispatch(fetchCartItems(i18n.language));
    }, [dispatch, i18n.language]);

    // الاستماع لتحديثات السلة من صفحات أخرى
    useEffect(() => {
        const handleCartUpdate = () => {
            dispatch(fetchCartItems(i18n.language));
        };

        window.addEventListener('cartUpdated', handleCartUpdate);
        
        return () => {
            window.removeEventListener('cartUpdated', handleCartUpdate);
        };
    }, [dispatch, i18n.language]);

    // حساب عدد المنتجات من Redux store
    const cartCount = totalQuantity || 0;

    return (
        <div className="fixed-cart-icon">
            <Link to="/cart" className="cart-icon-button" title={t("cart.viewCart", "عرض عربة التسوق")} style={{ position: 'relative' }}>
                <svg width="28" height="28" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 10V8.75C10 7.42392 10.5268 6.15215 11.4645 5.21447C12.4021 4.27678 13.6739 3.75 15 3.75C16.3261 3.75 17.5979 4.27678 18.5355 5.21447C19.4732 6.15215 20 7.42392 20 8.75V10M18.75 17.5V15M11.25 17.5V15" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                    <path d="M5 15C5 12.6425 5 11.465 5.7325 10.7325C6.465 10 7.6425 10 10 10H20C22.3575 10 23.535 10 24.2675 10.7325C25 11.465 25 12.6425 25 15V16.25C25 20.9637 25 23.3212 23.535 24.785C22.07 26.2487 19.7137 26.25 15 26.25C10.2863 26.25 7.92875 26.25 6.465 24.785C5.00125 23.32 5 20.9637 5 16.25V15Z" stroke="#fff" strokeWidth="2" />
                </svg>
                {cartCount > 0 && (
                    <span className="cart-count-badge" style={{
                        position: 'absolute',
                        top: '-8px',
                        right: '-8px',
                        background: '#EF7F03',
                        color: '#fff',
                        borderRadius: '50%',
                        width: '22px',
                        height: '22px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '11px',
                        fontWeight: 'bold',
                        zIndex: 2,
                        boxShadow: '0 2px 8px rgba(239, 127, 3, 0.5)',
                        border: '2px solid #fff',
                        minWidth: '22px',
                        textAlign: 'center'
                    }}>
                        {cartCount > 99 ? '99+' : cartCount}
                    </span>
                )}
            </Link>
        </div>
    );
};

export default FixedCartIcon; 